import { getCustomOptionPriceModifier } from './customOptionUtils';
const currencyToISO = (c) => c === 'KM' ? 'BAM' : c;

export const pixelTrack = (event, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', event, params);
  }
};

export const pixelPageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};

export const pixelViewContent = (product, currency, countryKey) => {
  if (!product) return;
  const iso = currencyToISO(currency);
  const price = product.is_on_sale && product.sale_discount_percentage > 0
    ? product[`discounted_${currency}`]
    : product[currency];
  const unitPrice = parseFloat(price) || 0;
  pixelTrack('ViewContent', {
    content_ids: String(product.id),
    content_type: 'product',
    content_name: product['name' + countryKey] || product.nameBA,
    contents: [{ id: String(product.id), quantity: 1, item_price: unitPrice }],
    value: unitPrice,
    currency: iso,
  });
};

export const pixelAddToCart = (product, qty, currency, customOption, countryKey) => {
  if (!product) return;
  const iso = currencyToISO(currency);
  let price = product.is_on_sale && product.sale_discount_percentage > 0
    ? product[`discounted_${currency}`]
    : product[currency];
  const modifier = getCustomOptionPriceModifier(product.custom_options, customOption, currency);
  if (modifier) price = parseFloat(price) + modifier;
  const unitPrice = parseFloat(price) || 0;
  pixelTrack('AddToCart', {
    content_ids: String(product.id),
    content_type: 'product',
    content_name: product['name' + countryKey] || product.nameBA,
    contents: [{ id: String(product.id), quantity: qty, item_price: unitPrice }],
    value: parseFloat((unitPrice * qty).toFixed(2)),
    currency: iso,
  });
};

// orderProducts: [{ id, qty, item_price }] — prices already resolved for user's currency
export const pixelInitiateCheckout = (orderProducts, subtotal, currency) => {
  const iso = currencyToISO(currency);
  pixelTrack('InitiateCheckout', {
    content_ids: orderProducts.map(i => String(i.id)).join(','),
    content_type: 'product',
    contents: orderProducts.map(i => ({ id: String(i.id), quantity: i.qty || 1, item_price: i.item_price || 0 })),
    num_items: orderProducts.reduce((s, i) => s + (i.qty || 1), 0),
    value: parseFloat(subtotal) || 0,
    currency: iso,
  });
};

// orderProducts: [{ id, qty, item_price }] — prices already resolved for user's currency
export const pixelPurchase = (orderProducts, total, currency, orderId) => {
  const iso = currencyToISO(currency);
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Purchase', {
      content_ids: orderProducts.map(i => String(i.id)).join(','),
      content_type: 'product',
      contents: orderProducts.map(i => ({ id: String(i.id), quantity: i.qty || 1, item_price: i.item_price || 0 })),
      num_items: orderProducts.reduce((s, i) => s + (i.qty || 1), 0),
      value: parseFloat(total) || 0,
      currency: iso,
    }, { eventID: String(orderId) });
  }
};
